<template>
  <div
    class="bgi"
    id="homeProject"
    :style="style=='shaodong'?'':{background:'url('+bgiBackground+') no-repeat center center'}"
  >
    <div class="colspan">
      <div class="header clearfix">
        <p class="p1 clearfix">
          <img :src="shakehandsImg" align="center" />
          <span>公益项目</span>
        </p>
        <p
          v-if="style=='shaodong'"
          @click="goto(recommendData[8].value.channel_id)"
          class="p2 clearfix"
        >更多></p>
      </div>
      <div class="main clearfix">
        <swiper
          :options="swiperOption"
          class="swiper-wrap"
          ref="mySwiper"
          v-if="projectList.length!=0"
        >
          <swiper-slide v-for="(item,index) in projectList" :key="index">
            <a :href="getURL(item)">
              <div class="img_box" :title="item.name">
                <img
                  v-if="item.cover_photo_text&&item.cover_photo_text.url"
                  :src="item.cover_photo_text.url"
                  alt
                />
                <img v-else :src="defaultImg" alt />
              </div>
              <p :title="item.name">{{item.name}}</p>
            </a>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="swiper-button-next" slot="button-next">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapActions } from "vuex";
export default {
  props: {
    recommendData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      projectList: [],
      currentList: [],
      bgRepeat: "no-repeat",
      style: "shaodong",
      bgiBackground: require("../../assets/images/shaodong/bg.png"),
      shakehandsImg: require("../../assets/images/shaodong/icon_shakehands.png"),
      length: 0,
      defaultImg: this.$store.state.webInfo.default_pic_text.url,
      swiperOption: {
        //循环
        loop: true,
        //自动播放
        autoplay: 3000,
        autoplayDisableOnInteraction:false,
        slidesPerView: 4,
        spaceBetween: 20,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next"
      }
    };
  },
  methods: {
    getURL(item) {
      return window.location.href + "pubProjectDetail?projectInfoId="+item.id;
    },
    goto(id) {
      if (id) {
        this.$db
          .get(this.$url.channel.url + "/" + id)
          .then(resp => {
            let data = resp.data;
            this.channelGoto(data);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    ...mapActions(["getWebconfigInfo"])
  },
  mounted() {
    this.$db
      .get(this.$url.project.list + "?if_show=1")
      .then(res => {
        if (res.code == 200 && res.data) {
          this.projectList = res.data;
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  created() {
    this.getWebconfigInfo()
      .then(res => {
        this.style = res.style ? res.style : "";
        if (this.style) {
          this.bgiBackground = require("../../assets/images/" +
            this.style +
            "/bg.png");
          this.shakehandsImg = require("../../assets/images/" +
            this.style +
            "/icon_shakehands.png");
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>
<style lang="less" scoped>
img {
  width: 100%;
}
.bgi {
  height: 370px;
  margin-top: 20px;
}
.colspan {
  margin: 0 auto;
  width: 1200px;
  > .header {
    width: 100%;
    color: #fff;
    height: 50px;
    .p1 {
      float: left;
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold;
      margin: 0;
      font-weight: 700;
      line-height: 50px;
      img {
        width: 30px;
      }
      span {
        display: inline-block;
      }
      .more {
        font-size: 14px;
        color: #888 !important;
        float: right;
      }
    }
    .p2 {
      cursor: pointer;
      margin: 0;
      line-height: 50px;
      float: right;
      font-size: 14px;
      color: #ccc;
    }
  }
  > .main {
    width: 100%;
    height: 280px;
    padding: 0 78px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    /deep/ .swiper-slide {
      height: 180px;
      margin-top: 40px;
      > a {
        text-decoration: none;
        > div {
          height: 135px;
          background-color: #fff;
          >img{
            width: 100%;
            height: 100%;
            border:0;
          }
        }
        > p {
          margin: 0;
          height: 45px;
          line-height: 45px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 0 10px;
        }
      }
    }

    /deep/ .swiper-button-prev,
    .swiper-button-next {
      border: 1px solid #fff;
      width: 40px;
      height: 40px;
      line-height: 40px;
      border-radius: 50%;
      color: #fff;
      background-image: none !important;
      text-align: center;
      font-size: 20px;
    }
    .swiper-button-prev:focus,
    .swiper-button-next:focus {
      outline: none;
    }
    .swiper-button-prev:hover,
    .swiper-button-next:hover {
      box-shadow: 5px 5px 10px rgba(160, 16, 14, 0.5);
    }
  }
  #swiper-button-next:focus {
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/project.vue